import React, { createContext, useState, useContext, useEffect } from 'react';
import { strings } from '../localization/strings';
import { useNavigate, useLocation } from 'react-router-dom';
import eventManager from '../utils/analytics/EventManager';

export const LanguageContext = createContext();

// Custom hook for using language context
export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
    const [currentLang, setCurrentLang] = useState('tr');
    const navigate = useNavigate();
    const location = useLocation();
    
    // URL'den dili belirle
    useEffect(() => {
        if (location.pathname.startsWith('/en')) {
            setCurrentLang('en');
        } else {
            setCurrentLang('tr');
        }
    }, [location.pathname]);
    
    // Dil değiştirme fonksiyonu
    const toggleLanguage = (lang) => {
        if (lang === currentLang) return;
        
        // Yeni URL oluştur
        let newPath;
        if (lang === 'en') {
            // Türkçe'den İngilizce'ye geçiş
            newPath = `/en${location.pathname}`;
        } else {
            // İngilizce'den Türkçe'ye geçiş
            newPath = location.pathname.replace(/^\/en/, '');
        }
        
        // Eğer kök dizine geçiyorsa ve boş string oluştuysa, / ekle
        if (newPath === '') newPath = '/';
        
        // Dil değiştirme eventi gönder
        eventManager.trackEvent('language_change', {
            from_language: currentLang,
            to_language: lang,
            page_path: location.pathname,
            page_title: document.title
        });
        
        setCurrentLang(lang);
        navigate(newPath);
    };
    
    const t = (key) => {
        try {
            // "navbar.home" gibi nested key'leri parse edip değeri döndürür
            return key.split('.').reduce((o, i) => o[i], strings[currentLang]);
        } catch (error) {
            console.warn(`Translation key not found: ${key}`);
            return key;
        }
    };

    return (
        <LanguageContext.Provider value={{ currentLang, setCurrentLang, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
}; 